var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "subTab": "",
      "sh": "About us",
      "index": "01",
      "total": "04",
      "tabActive": "회사 프로필",
      "bg": "/images/sub/visual/sv1.jpg"
    }
  }), _c('section', {
    staticClass: "section section--first pb-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg dot-tit"
  }, [_vm._v("회사 프로필")])])]), _c('div', {
    staticClass: "cover-bg py-40 py-md-60 py-lg-90",
    staticStyle: {
      "background-image": "url(/images/sub/aboutus/company-profile-bg.jpg)"
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "4",
      "order-md": "2",
      "offset-lg": "1"
    }
  }, [_c('div', {
    staticClass: "mb-20"
  }, [_c('v-img', {
    staticClass: "mx-auto mt-lg-n180",
    attrs: {
      "max-width": "464",
      "aspect-ratio": 464 / 250,
      "src": "/images/sub/aboutus/company-profile-logo.jpg"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7",
      "order-md": "1"
    }
  }, [_c('div', {
    staticClass: "page-text white--text"
  }, [_c('p', [_vm._v("케이아이이 시스템즈는 다양한 산업군을 대상으로 분석기 시스템에 대한 엔지니어링 및 통합 분야에서 풍부한 경험과 노하우를 보유하고 있습니다. 이를 기반으로 고객의 요구사항에 따라 맞춤형 분석기 패키지 시스템을 제공하고 최적화된 솔루션으로 고객의 요구사항을 만족시키기 위해 항상 최선을 다합니다.")]), _c('p', [_vm._v("케이아이이 시스템즈의 이러한 노력은 유해한 화학물질과 가스가 포함된 다양한 산업 분야에서의 요구사항을 충족시키는데 큰 역할을 합니다.")]), _c('p', [_vm._v("케이아이이 시스템즈는 제품에 대한 신뢰성을 높이기 위해, 2003년부터 ISO9001인증을 보유하고 있습니다. 지속적으로 품질을 개선하고자 품질경영시스템을 도입하여 시행하고 있으며, 이를 통해 고객사에게 상당한 이점을 제공할 수 있습니다.")])])])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit top-line-tit"
  }, [_vm._v("산업 분야")])]), _c('v-item-group', {
    attrs: {
      "mandatory": ""
    }
  }, [_c('v-row', _vm._l(_vm.items, function (item, i) {
    return _c('v-item', {
      key: i,
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref) {
          var active = _ref.active,
              toggle = _ref.toggle;
          return [_c('v-col', {
            staticClass: "transition",
            attrs: {
              "cols": "12",
              "md": active ? '6' : '2'
            }
          }, [_c('v-card', {
            staticClass: "cursor-pointer",
            attrs: {
              "tile": "",
              "elevation": "0"
            },
            on: {
              "mouseenter": toggle
            }
          }, [_c('v-img', {
            staticClass: "w-100 h-200px h-md-500px",
            staticStyle: {
              "position": "relative"
            },
            attrs: {
              "cover": "",
              "src": active ? item.srcOn : item.src
            }
          }, [_c('div', {
            staticClass: "w-100 h-100",
            class: active ? 'd-flex' : ''
          }, [_c('v-overlay', {
            staticClass: "mt-auto pa-20 px-md-60 py-md-32 h-100",
            class: active ? 'h-100px justify-start' : '',
            attrs: {
              "absolute": "",
              "opacity": "0.4",
              "color": "#000"
            }
          }, [_c('div', {
            class: active ? 'font-size-20 font-size-md-26' : 'font-size-16 font-size-md-18 text-center'
          }, [_c('div', {
            class: {
              'd-inline-block': active
            }
          }, [_vm._v(_vm._s(item.num))]), _c('div', {
            staticClass: "font-weight-bold",
            class: {
              'd-inline-block pl-6 pl-md-10': active
            }
          }, [_vm._v(_vm._s(item.title))])])])], 1)])], 1)], 1)];
        }
      }], null, true)
    });
  }), 1)], 1)], 1)], 1), _c('section', {
    staticClass: "section grey-f7"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h3', {
    staticClass: "tit top-line-tit"
  }, [_vm._v("핵심 역량")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('p', {
    staticClass: "page-text pt-lg-18"
  }, [_vm._v(" 케이아이이 시스템즈는 다양한 유형의 분석기 시스템을 설계, 엔지니어링 및 개발하는 데 핵심 역량을 갖추고 있습니다. 연구 및 엔지니어링에 대한 높은 업무 집중도를 가지고 있어 혁신적인 기술 개발에 앞장서며, 광범위한 계기 및 분석기 시스템에 대한 솔루션을 제공합니다. 케이아이이 시스템즈는 분석기 시스템 분야에서 선두에 위치하고 있습니다. ")])])], 1)], 1)])], 1), _c('section', {
    staticClass: "section section--last pt-0 mt-n80 mt-md-n120 mt-lg-n160"
  }, [_c('v-container', [_c('div', {
    staticClass: "core-competencies-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "potision": "relative"
    },
    attrs: {
      "tile": "",
      "color": "white",
      "elevation": "0",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card-num"
  }, [_vm._v("01")]), _c('div', {
    staticClass: "px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90"
  }, [_c('div', {
    staticClass: "mb-16 mb-md-24"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v("일하는 방식")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v(" 케이아이이 시스템즈는 변화하는 시장에 대응하기 위해 유연한 비즈니스 능력을 중요시하며, 각 지역의 요구사항을 이해하고 대응함으로써 국제적 입지를 확보하여 경쟁 우위를 유지하고 있습니다. ")]), _c('p', [_vm._v(" 케이아이이 시스템즈는 최고 수준의 품질과 기술력을 유지하기 위해 제조 기술뿐만 아니라 프로세스 분석기 시스템 (Process Analyzer System)에 특화된 프로젝트 관리, 서비스 센터 및 24시간 온라인 기술지원도 제공합니다. ")])])])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/aboutus/company-profile-slide.jpg"
    }
  })])], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "potision": "relative"
    },
    attrs: {
      "tile": "",
      "color": "white",
      "elevation": "0",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card-num"
  }, [_vm._v("02")]), _c('div', {
    staticClass: "px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90"
  }, [_c('div', {
    staticClass: "mb-16 mb-md-24"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v("엔지니어링 능력")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v(" 케이아이이 시스템즈는 25명 이상의 엔지니어로 구성된 엔지니어 팀을 보유하고 있으며, 제조, 기술 및 서비스 전문가들이 고객의 비즈니스를 전담하여 지원합니다. 품질관리에 대한 높은 관심과 적절한 인력 배치를 통해 케이아이이 시스템즈는 항상 최상의 품질의 제품과 서비스를 제공합니다. ")])])])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/aboutus/company-profile-slide2.jpg"
    }
  })])], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "potision": "relative"
    },
    attrs: {
      "tile": "",
      "color": "white",
      "elevation": "0",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card-num"
  }, [_vm._v("03")]), _c('div', {
    staticClass: "px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90"
  }, [_c('div', [_c('div', {
    staticClass: "mb-16 mb-md-24"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v("생산 능력")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_vm._v(" 케이아이이 시스템즈는 크기가 가로 5m * 세로 3m * 높이 2.7m인 쉘터를 기준으로 연간 약 100개의 분석기 패키지 시스템을 제작할 수 있습니다. ")])], 1)], 1)]), _c('div', {
    staticClass: "mt-30 mt-md-46"
  }, [_c('div', {
    staticClass: "mb-16 mb-md-24"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v("공장 설비")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_vm._v(" 제작동 크기 : 31mW * 32.5mD ")])], 1), _c('v-row', {
    staticClass: "row--small mt-6"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_vm._v(" 검사동 크기 : 15mW * 32.5mD ")])], 1), _c('v-row', {
    staticClass: "row--small mt-6"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', {
    staticStyle: {
      "letter-spacing": "-.03em !important"
    },
    attrs: {
      "cols": ""
    }
  }, [_vm._v(" 회의실 / 창고 / 사무실 / 제작 및 검사 장비 ")])], 1)], 1)])])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/aboutus/company-profile-slide3.jpg"
    }
  })])], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "potision": "relative"
    },
    attrs: {
      "tile": "",
      "color": "white",
      "elevation": "0",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card-num"
  }, [_vm._v("04")]), _c('div', {
    staticClass: "px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90"
  }, [_c('div', {
    staticClass: "mb-16 mb-md-24"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v("애프터서비스")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v(" 케이아이이 시스템즈는 프로젝트 완료 후에도 고객에게 지속적으로 SAT, 현장 시운전 및 분석기 교육, 문제 해결(Troubleshooting) 등과 같은 서비스를 제공하며 지원합니다. ")])])])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/aboutus/company-profile-slide4.jpg"
    }
  })])], 1)], 1)]), _c('div', {
    staticClass: "swiper-control"
  }, [_c('v-btn', {
    staticClass: "swiper-prev border-1 mr-6 mr-lg-10",
    attrs: {
      "icon": "",
      "outlined": "",
      "large": "",
      "color": "grey-d"
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow-grey"
  })]), _c('v-btn', {
    staticClass: "swiper-next border-1",
    attrs: {
      "icon": "",
      "outlined": "",
      "large": "",
      "color": "grey-d"
    }
  }, [_c('i', {
    staticClass: "icon icon-right-arrow-grey"
  })])], 1)])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }